module.exports = __webpack_public_path__ + "static/media/trash-restore-alt.0d2002e5.svg";